export default "__VITE_ASSET__D72FSBgY__"